import React, { Component } from 'react';

type TableProps = {
    label?: string;
    headers: Array<JSX.Element | string>;
    data:  Array<Array<JSX.Element | string>>;
    note?: string;
    addClassToRow?: (index : number) => string;
};

export class FstyrTable extends Component<TableProps> {

    constructor(props: TableProps) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="fstyr-table-responsive-scroll">
                <p className="fstyr-table-title" >{this.props.label}</p>
                <table className="fstyr-table table">
                    <thead>
                        <tr>
                            {this.props.headers.map((header, i : number) =>
                                <th key={"h" + i}>{header}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody style={{ padding: "10px" }}>
                        {(this.props.data)?.map((dataRow, i) =>
                            <tr className={this.props.addClassToRow ? this.props.addClassToRow(i) : ""} key={i}>
                                {(dataRow).map((cellData, j) => {
                                    return (
                                        <td key={i + "-" + j}>{cellData}</td>
                                    )
                                })}
                            </tr>
                        )}
                    </tbody>
                </table>
                <p className="fstyr-table-note" >{this.props.note}</p>
            </div>
        );
    }
}